







































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";
import KyashChargeKey from "@/components/kyash-charge-key";

export default createComponent({
  components: {},
  setup() {
    const kyashChargeStore = inject(KyashChargeKey);
    if (!kyashChargeStore) {
      throw new Error(`${KyashChargeKey} is not provided`);
    }

    const message = computed(() => kyashChargeStore.errorMessage);

    return {
      message
    };
  }
});
